import styled from 'styled-components';

export const Container = styled.ul`
  margin-top: 16px;
  padding-inline-start: 0;
  list-style: none;

  li {
    color: #444;

    & + li {
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px solid #eee;
    }
  }

  .video-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.72);
    z-index: 1300;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }

  .video-modal {
    width: min(860px, 100%);
    background: #111;
    border-radius: 10px;
    padding: 12px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);
  }

  .video-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    color: #fff;
    margin-bottom: 10px;
    font-size: 13px;

    button {
      border: 0;
      background: transparent;
      color: #fff;
      cursor: pointer;
      display: inline-flex;
      padding: 4px;
    }
  }

  .video-modal video {
    width: 100%;
    max-height: 75vh;
    border-radius: 6px;
    background: #000;
    display: block;
  }
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;

  > div {
    display: flex;
    flex-direction: column;
    min-width: 0;

    strong {
      font-size: 12px;
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 280px;
    }

    span {
      font-size: 11px;
      color: #999;
      margin-top: 2px;
    }
  }
`;

export const FileActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  a {
    display: inline-flex;
    align-items: center;
  }

  .preview-btn,
  .delete-btn {
    border: 0;
    background: transparent;
    cursor: pointer;
    font-size: 12px;
    padding: 0;
  }

  .preview-btn {
    color: #1565c0;
  }

  .delete-btn {
    color: #e57878;
  }
`;

export const Preview = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 6px;
  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  margin-right: 10px;
  flex-shrink: 0;
  border: 1px solid #e6e6e6;
`;

export const PreviewBadge = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 6px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  flex-shrink: 0;
`;
